import { Element, Component, Prop, h} from '@stencil/core';
import sparkline from "@fnando/sparkline";

@Component({
  tag: 'uui-spark-graph',
  styleUrl: 'uui-spark-graph.css',
  shadow: true
})

export class UUISparkGraph {
  @Element() host: HTMLDivElement;
  @Prop() width: string = '100';
  @Prop() height: string = '50';
  @Prop() strokeWidth: string;
  @Prop() data: string;
  @Prop() color: string = 'red';
  @Prop() fill: string='none'

  componentDidLoad() {
    let svg  = this.host.shadowRoot.querySelector('svg');
    sparkline(svg,JSON.parse(this.data));
    svg.style.stroke = this.color;
    svg.style.fill = this.fill;
  }

  render() {
    return <svg
    class="sparkline"
    width={this.width}
    height={this.height}
    stroke-width={this.strokeWidth}
  ></svg>;
  }
}
